module.exports = __webpack_public_path__ + "img/logo_paijie.4b4f156e.png";